import { autoinject, transient, computedFrom, useView } from "aurelia-framework";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { AttachmentClientService } from "../../../../../../services/attachment/attachments-client.service";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { QueriesClientService } from "../../../../../../services/queries/queries-client.services";
import { RightshipEntityAttachmentManager } from "../../../common-steps/rightship-entity-attachment/rightship-entity-attachment-manager";
import { BindingSignaler } from "aurelia-templating-resources";
import { SignalClientService } from "@rightship-tech/common-ui/services/basic/signal-client.service";
import { SignalFunctions } from "../../../../../../services/basics/signal-functions";
import * as Enumerable from "linq";

@autoinject
@transient()
@useView('views/pages/modules/custom-reports/custom-report/steps/custom-report-exports.html')
export class CustomReportExports extends RightshipEntityAttachmentManager {

    public inProgress: string = "In Progress";
    public failed: string = "Failed";

    @computedFrom('rootItem', 'getItemId', 'entityId')
    public get canAdd(): boolean {
        return false;
    }

    @computedFrom('rootItem', 'getItemId')
    public get canDelete(): boolean {
        return false;
    }

    constructor(attachmentClientService: AttachmentClientService,
        notificationService: NotificationClientService,
        userClaimsService: UserClaimsService,
        dialogService: DialogClientService,
        i18N: I18N,
     queriesClientService: QueriesClientService,
        private signalClientService: SignalClientService,
        bindingSignaler: BindingSignaler) {
        super(attachmentClientService, notificationService, userClaimsService, dialogService, i18N, queriesClientService, bindingSignaler);
    }

    activateOverride(root: any) {
        super.activateOverride(root);
        this.signalClientService.subscribe(SignalFunctions.exportCustomReportStarted, this.exportCustomReportStarted);
        this.signalClientService.subscribe(SignalFunctions.exportCustomReportReady, this.onExportCustomReportReady);
    }

    deactivate() {
        this.signalClientService.unsubscribe(SignalFunctions.exportCustomReportStarted, this.exportCustomReportStarted);
        this.signalClientService.unsubscribe(SignalFunctions.exportCustomReportReady, this.onExportCustomReportReady);
    }

    exportCustomReportStarted = (params: {
        customReportId: number,
        entityAttachmentId: number
    }) => {
        if (this.rootItem["customReportId"] == params.customReportId) {
            this.loadAttachments();
        }
    }

    onExportCustomReportReady = (params: {
        customReportId: number,
        entityAttachmentId: number
    }) => {
        if (this.rootItem["customReportId"] == params.customReportId) {
            this.loadAttachments();
        }
    }

    public loadAttachments() {
        return new Promise<void>((resolve, reject) => {
            if (this.isLoadingAttachments || !this.shouldLoadAttachments) {
                resolve();
                return;
            }

            this.isLoadingAttachments = true;

            this.items = [];

            this.queriesClientService.getData('odata/RightShipAttachments/GetAttachments(entityTypeId=24,entityId=' + (<any>this.rootItem).id + ')').then(results => {
                this.items = Enumerable.from<any>(results.value).orderByDescending(c => new Date(c.createdDate)).toArray();
                if (this.onAttachmentsLoaded) {
                    this.onAttachmentsLoaded();
                }
                this.isLoadingAttachments = false;
                resolve();
            }).catch(() => {
                this.isLoadingAttachments = false;
                reject();
            });
        });
    }
}